import { useEffect, useState } from 'react';

import { AnimatePresence, motion } from 'motion/react';

import { cn } from '@/utils/tailwind';

interface SearchbarRotatingPromptPlaceholderProps {
  text: string;
}

const promptTransition = {
  duration: 0.25,
  ease: 'easeOut' as const,
};

export const SearchbarRotatingPromptPlaceholder = ({
  text,
}: SearchbarRotatingPromptPlaceholderProps) => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const updatePreference = () => {
      setPrefersReducedMotion(mediaQuery.matches);
    };

    updatePreference();
    mediaQuery.addEventListener('change', updatePreference);
    return () => mediaQuery.removeEventListener('change', updatePreference);
  }, []);

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-y-0 right-[60px] left-0 flex items-center overflow-hidden pl-4"
      data-testid="SearchPromptPlaceholder"
    >
      <AnimatePresence initial={false} mode="wait">
        <motion.span
          key={text}
          animate={{ opacity: 1, y: 0 }}
          className={cn('text-grayscale-gray4 truncate text-start text-base')}
          exit={prefersReducedMotion ? undefined : { opacity: 0, y: -4 }}
          initial={prefersReducedMotion ? false : { opacity: 0, y: 4 }}
          transition={prefersReducedMotion ? { duration: 0 } : promptTransition}
        >
          {text}
        </motion.span>
      </AnimatePresence>
    </div>
  );
};
